import axios from 'axios';

import { axiosHeaderV2, getV2RootUrl } from 'common/helpers/apiHelper';
import { customerId } from 'common/helpers/tokenHelper';

export const listCustomerGiftCard = () =>
  axios.get(
    `${getV2RootUrl()}/customer/${customerId()}/gift-card/for-web`,
    axiosHeaderV2()
  );

export const registerCustomerGiftCard = (data) =>
  axios.put(
    `${getV2RootUrl()}/customer/${customerId()}/gift-card/register`,
    data,
    axiosHeaderV2()
  );
